import React, { useMemo } from 'react';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

function CustomLineChart({ data, dsData }) {
    const safeData = Array.isArray(data) && data.length > 0 ? data : [];

    let yTitle;
    switch (dsData.class) {
        case '원자재':
            yTitle = `${dsData.class} (${dsData.indexDim[0]})`;
            console.log("yTitle", yTitle)
            break;
        case '하중':
            yTitle = `${dsData.class} (${dsData.indexDim[0]})`;
            console.log("yTitle", yTitle)
            break;
        case '치수':
            yTitle = `${dsData.class} (${dsData.indexDim[0]})`;
            console.log("yTitle", yTitle)
            break;
        default:
            yTitle = '값';
    }
    const colorArr = ['#0A2B83', '#45BFCE'];
    const aniDura = 500;
    const data1Arr = safeData.map((el) => parseFloat(el.data1));
    const data2Arr = safeData.map((el) => parseFloat(el.data2 ?? 0));
    const timeArr = safeData.map((el) => parseFloat(el.time));
    const maxY = safeData.length ? Math.ceil(Math.max(...data1Arr, ...data2Arr)) : 1;
    const minY = safeData.length ? Math.floor(Math.min(...data1Arr, ...data2Arr)) : 0;
    const tick = Math.ceil((maxY - minY) / 5) || 1;
    const maxDomain = Math.ceil(maxY / tick) * tick;
    const minDomain = Math.floor(minY / tick) * tick;
    const startTime = timeArr.length > 0 ? timeArr[0] || 0 : 0;
    const endTime = timeArr.length > 0 ? timeArr[timeArr.length - 1] || 0 : 0;

    const yTickArr = [];
    for (let i = 0; i <= Math.ceil((maxDomain - minDomain) / tick); i++) {
        yTickArr.push(minDomain + tick * i);
    }

    /** 데이터 포인트마다 눈금 (행 순서 = time 배열) */
    const xAxisTicks = useMemo(
        () => safeData.map((el) => parseFloat(el.time)),
        [safeData]
    );

    return (
        <div className="chartArea">
            <span className="axisTitle y">{yTitle}</span>
            <span className="axisTitle x">시간 (초)</span>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={safeData} margin={{ top: 8, right: 20, left: 0, bottom: 4 }}>
                    <CartesianGrid horizontal={true} vertical={false} />
                    <XAxis
                        dataKey="time"
                        type="number"
                        domain={[startTime, endTime]}
                        ticks={xAxisTicks}
                        tickLine={false}
                        height={52}
                        angle={35}
                        textAnchor="start"
                        tickMargin={8}
                        tick={{ fontSize: 12, fill: '#333' }}
                        allowDecimals={true}
                        tickFormatter={(xTick) => parseFloat(xTick).toFixed(2)}
                    />
                    <YAxis
                        axisLine={false}
                        type="number"
                        tickLine={false}
                        ticks={yTickArr}
                        domain={[minDomain, maxDomain]}
                        tick={{ fontSize: 12, fill: '#333' }}
                        width={48}
                    />
                    {dsData.indexType.map((type, index) => {
                        if (dsData.valView[index]) {
                            return (
                                <Line
                                    key={`lineChart_${index}`}
                                    type={type === 'TINYINT' ? 'step' : 'monotone'}
                                    dataKey={`data${index + 1}`}
                                    stroke={colorArr[index]}
                                    dot={false}
                                    animationDuration={aniDura}
                                />
                            );
                        }
                        return null;
                    })}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export default React.memo(CustomLineChart);
